export default __webpack_public_path__ + "static/media/add-item.526c574e.svg";